/* ─── Featured products grid: mobile wave pin ────────────────────────────── */
const mobileQuery = window.matchMedia('(max-width: 767.98px)');

(function () {
  function getHeaderH() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  }

  function pin(svg, headerH, cache) {
    Object.assign(svg.style, { position: 'fixed', top: headerH + 'px', left: '0', right: '0', zIndex: '1' });
    // Measure SVG height once per pin session so the tail threshold is pixel-perfect
    if (!cache.svgH) cache.svgH = svg.getBoundingClientRect().height;
  }

  function reset(outer, svg) {
    svg.style.cssText = '';
    outer.removeAttribute('data-wave-phase');
  }

  function update(outer, svg, cache) {
    if (!mobileQuery.matches) { reset(outer, svg); return; }

    const { top, bottom, height } = outer.getBoundingClientRect();
    const vh       = window.innerHeight;
    const headerH  = getHeaderH();

    // Idle: section too short, not yet scrolled under header, or fully above viewport
    if (height <= vh || top > headerH || bottom <= 0) { reset(outer, svg); return; }

    // Tail: switch when section bottom aligns with the fixed wave's bottom edge —
    //       that's the only point where absolute(bottom:0) and fixed(top:headerH) match.
    //       Fall back to vh if we haven't measured yet (edge case).
    const tailAt = cache.svgH ? headerH + cache.svgH : vh;
    if (bottom <= tailAt) { svg.style.cssText = ''; outer.setAttribute('data-wave-phase', 'tail'); return; }

    pin(svg, headerH, cache);
  }

  function initWave(outer) {
    const svg = outer.querySelector('.featured-products-grid__wave--mobile svg');
    if (!svg) return;

    const cache = { svgH: 0 }; // reset on resize so height is re-measured after layout changes
    let bound = false, ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(outer, svg, cache); });
    }

    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (!bound) { window.addEventListener('scroll', onScroll, { passive: true }); bound = true; }
        update(outer, svg, cache);
      } else if (bound) {
        window.removeEventListener('scroll', onScroll);
        bound = false;
        reset(outer, svg);
      }
    }, { rootMargin: '80px 0px 80px 0px' }).observe(outer);

    window.addEventListener('resize', () => { cache.svgH = 0; update(outer, svg, cache); }, { passive: true });
    mobileQuery.addEventListener('change', () => { cache.svgH = 0; update(outer, svg, cache); });
  }

  function init() {
    document.querySelectorAll('.featured-products-grid__outer').forEach(initWave);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

if (!customElements.get('featured-products-carousel')) {
  customElements.define('featured-products-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.featured-products-carousel__track');
      this.prevBtn = this.querySelector('.featured-products-carousel__btn--prev');
      this.nextBtn = this.querySelector('.featured-products-carousel__btn--next');
      this.counter = this.querySelector('.featured-products-carousel__counter');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this._index = 0;

      this.prevBtn.addEventListener('click', () => {
        this._index = Math.max(0, this._index - 1);
        this.scrollToIndex(this._index);
        this.updateNav();
      });

      this.nextBtn.addEventListener('click', () => {
        this._index = Math.min(this.slideCount - 1, this._index + 1);
        this.scrollToIndex(this._index);
        this.updateNav();
      });

      this.updateNav();
    }

    get slideCount() {
      return this.querySelectorAll('.featured-products-carousel__slide').length;
    }

    scrollToIndex(index) {
      const slide = this.querySelectorAll('.featured-products-carousel__slide')[index];
      if (!slide) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollTo({ left: index * (slide.offsetWidth + gap), behavior: 'smooth' });
    }

    updateNav() {
      if (!mobileQuery.matches) return;
      const total = this.slideCount;
      this.prevBtn.disabled = this._index <= 0;
      this.nextBtn.disabled = this._index >= total - 1;
      if (this.counter) {
        this.counter.textContent = total > 0 ? `${this._index + 1}/${total}` : '';
      }
    }
  });
}
